import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_checkbox = _resolveComponent("v-checkbox");
    const _component_v_data_table_virtual = _resolveComponent("v-data-table-virtual");
    return (_openBlock(), _createBlock(_component_v_data_table_virtual, {
        modelValue: _ctx.checkedList,
        "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event) => ((_ctx.checkedList) = $event)),
            _ctx.handleClickCheckBox
        ],
        hover: "",
        class: "share-store-list-data-table brg-table brg-checkbox-table",
        "hide-default-footer": "",
        "must-sort": "",
        "fixed-header": "",
        "show-select": "",
        "no-data-text": _ctx.localeInfo.noDataText,
        items: _ctx.getterHubStoreList,
        headers: _ctx.shareInfoConfigStoreListTableHeader,
        "sort-by": _ctx.sortBy,
        "items-per-page": -1,
        "return-object": "",
        density: "compact",
        "item-height": "37"
    }, {
        [`header.data-table-select`]: _withCtx(({ someSelected, allSelected, selectAll }) => [
            _createVNode(_component_v_checkbox, {
                "model-value": allSelected,
                indeterminate: someSelected && !allSelected,
                density: "compact",
                "hide-details": "",
                "onUpdate:modelValue": (value) => selectAll(value)
            }, null, 8 /* PROPS */, ["model-value", "indeterminate", "onUpdate:modelValue"])
        ]),
        [`item.data-table-select`]: _withCtx(({ isSelected, toggleSelect, internalItem }) => [
            _createVNode(_component_v_checkbox, {
                "model-value": isSelected([internalItem]),
                density: "compact",
                "hide-details": "",
                onclick: _ctx.withModifiers(() => toggleSelect(internalItem), ['stop'])
            }, null, 8 /* PROPS */, ["model-value", "onclick"])
        ]),
        bottom: _withCtx(() => _cache[1] || (_cache[1] = [])),
        _: 2 /* DYNAMIC */
    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "no-data-text", "items", "headers", "sort-by", "onUpdate:modelValue"]));
}
